'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _withoutLink2 = require('./withoutLink');

var _withoutLink3 = _interopRequireDefault(_withoutLink2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function (_withoutLink) {
  (0, _inherits3.default)(Button, _withoutLink);

  function Button() {
    (0, _classCallCheck3.default)(this, Button);
    return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  (0, _createClass3.default)(Button, [{
    key: 'renderLinkButton',
    value: function renderLinkButton() {
      return _react2.default.createElement(
        _reactRouter.Link,
        { to: this.props.to, className: 'os_buttonLink' },
        this.renderButton()
      );
    }
  }]);
  return Button;
}(_withoutLink3.default);

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/Button/index.js
// module id = 8
// module chunks = 0